import { SVGProps } from 'react';

export const MultiSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="241"
    height="241"
    viewBox="0 0 241 241"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M241 120.5C241 104.676 237.883 89.0064 231.827 74.3866C225.772 59.7669 216.896 46.4831 205.706 35.2936C194.517 24.1042 181.233 15.2282 166.613 9.17251C151.994 3.11682 136.324 -6.91701e-07 120.5 0L120.5 120.5H241Z"
      fill="#305A6E"
    />
    <path
      d="M120.5 241C136.324 241 151.994 237.883 166.613 231.827C181.233 225.772 194.517 216.896 205.706 205.706C216.896 194.517 225.772 181.233 231.827 166.613C237.883 151.994 241 136.324 241 120.5L120.5 120.5L120.5 241Z"
      fill="#D8EAF3"
    />
    <path
      d="M0 120.5C0 136.324 3.11682 151.994 9.17252 166.613C15.2282 181.233 24.1042 194.517 35.2936 205.706C46.4831 216.896 59.7669 225.772 74.3867 231.827C89.0064 237.883 104.676 241 120.5 241L120.5 120.5L0 120.5Z"
      fill="#AAD1E4"
    />
    <path
      d="M120.5 -5.26722e-06C104.676 -4.57552e-06 89.0064 3.11682 74.3866 9.17251C59.7669 15.2282 46.4831 24.1042 35.2936 35.2936C24.1042 46.4831 15.2282 59.7669 9.17251 74.3866C3.11682 89.0064 -6.65063e-06 104.676 -5.26722e-06 120.5L120.5 120.5L120.5 -5.26722e-06Z"
      fill="#4D7B92"
    />
  </svg>
);
